<div class="share-invoice-wrapper" (click)="onWrapClick($event)">
  <button class="np-share-button" *ngIf="!isShowShare" mat-icon-button (click)="share()" matTooltipPosition="above" matTooltip="Поділитися статусом">
    <mat-icon>share</mat-icon>
  </button>
</div>
